export const configs = {

    'Processadores' : ['TDP', 'Boost Clock', 'Marca', 'Clock', 'CoolerBox', 'Cores', 'Modelo', 'OnBoard', 'Socket'],
    'Processador' : ['TDP', 'Boost Clock', 'Marca', 'Clock', 'CoolerBox', 'Cores', 'Modelo', 'OnBoard', 'Socket'],

    'Placas de Vídeo' : ['Interface VRAM', 'Capacidade VRAM', 'Tecnologia VRAM', 'Boost Clock', 'Marca', 'Clock', 'Tamanho', 'Modelo', 'Retail Name', 'TDP'],
    'Placa de Vídeo' : ['Interface VRAM', 'Capacidade VRAM', 'Tecnologia VRAM', 'Boost Clock', 'Marca', 'Clock', 'Tamanho', 'Modelo', 'Retail Name', 'TDP'],

    'Coolers': ['Marca', 'Fan RPM', 'Fan AirFlow', 'Altura', 'Modelo', 'Nivel de Ruído', 'Socket', 'Tipo'],
    'Cooler': ['Marca', 'Fan RPM', 'Fan AirFlow', 'Altura', 'Modelo', 'Nivel de Ruído', 'Socket', 'Tipo'],

    'Placas-Mãe' : ['Capacidade RAM', 'Tecnologia RAM', 'Marca', 'Chipset', 'Form Factor', 'Modelo', 'Socket'],
    'Placa-Mãe' : ['Capacidade RAM', 'Tecnologia RAM', 'Marca', 'Chipset', 'Form Factor', 'Modelo', 'Socket'],

    'Memórias RAM' : ['Marca', 'Capacidade', 'Clock', 'Latência', 'Modelo', 'Tecnologia'],
    'Memória RAM' : ['Marca', 'Capacidade', 'Clock', 'Latência', 'Modelo', 'Tecnologia'],

    'Fontes' : ['Marca', 'Certificação', 'Modelo', 'Modular', 'Potência', 'Tamanho'],
    'Fonte' : ['Marca', 'Certificação', 'Modelo', 'Modular', 'Potência', 'Tamanho'],

    'Gabinetes' : ['Marca', 'Cor', 'Dimensões', 'Tamanho Maximo GPU', 'Modelo', 'Form Factor'],
    'Gabinete' : ['Marca', 'Cor', 'Dimensões', 'Tamanho Maximo GPU', 'Modelo', 'Form Factor'],

    'Armazenamentos' : ['Marca', 'Tipo de Conexão', 'Modelo', 'Geração PCI', 'Capacidade', 'Tipo'],
    'Armazenamento' : ['Marca', 'Tipo de Conexão', 'Modelo', 'Geração PCI', 'Capacidade', 'Tipo'],

    qualConfig: function(array) {

        if (array.includes('on_board')) {
            return this['Processadores']
        } 
        
        else if (array.includes('VRAM_interface')) {
            return this['Placas de Vídeo']
        } 

        else if (array.includes('fan_RPM')) {
            return this['Coolers']
        } 

        else if (array.includes('RAM_technology')) {
            return this['Placas-Mãe']
        } 

        else if (array.includes('latency')) {
            return this['Memórias RAM']
        } 

        else if (array.includes('modular')) {
            return this['Fontes']
        } 

        else if (array.includes('max_gpu_length')) {
            return this['Gabinetes']
        } 

        else if (array.includes('connection_type')) {
            return this['Armazenamentos']
        }

        else {
            return [...array]
        }

    }
}